import Hero from "@/components/Hero";
import About from "@/components/About";
import ServicesPreview from "@/components/ServicesPreview";
import WhyUs from "@/components/WhyUs";
import CTA from "@/components/CTA";
import SEO from "@/components/SEO";
import { WorkPreview } from "@/components/portfolio/WorkPreview";
import { useLanguage } from "@/i18n/LanguageContext";

export default function HomePage() {
  const { t } = useLanguage();
  return <>
    <SEO title={`Shylov Cleaning | ${t("studio.heroLine")}`} description={t("services.pageDesc")}
      image="/images/work/apartment-06-1600.webp" url="/" keywords="mobile car detailing, on-site detailing, apartment cleaning, yacht cleaning, marble restoration, Nice, Cannes, Monaco" />
    <div data-testid="home-page"><Hero /><WorkPreview /><ServicesPreview /><About /><WhyUs /><CTA /></div>
  </>;
}